<template>
  <button
    class="text-xl font-medium text-brand text-nowrap"
    @click="handleMassPaymentStart"
  >
    + {{ $t('MassPayments | header | create') }}
  </button>

  <base-modal
    name="usage-agreement-modal"
    :visible="showUsageAgreement"
    close-button
    close-outside
    @close="showUsageAgreement = false"
  >
    <usage-agreement-payroll @on-sign="onSignAgreement" />
  </base-modal>

  <modal-create-mass-payment
    v-model="showCreateMassPayment"
    @successManual="openInviteModal"
  />

  <mass-payment-invite-user-modal
    v-model="showInviteModal"
    @on-close="onCloseInviteModal"
  />
</template>

<script setup>
import { computed, ref } from 'vue'

import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import BaseModal from '@emcd-shared/base-modal'
import ModalCreateMassPayment from '@/widgets/ModalCreateMassPayment/ModalCreateMassPayment.vue'
import MassPaymentInviteUserModal from '@/widgets/MassPaymentInviteUserModal/MassPaymentInviteUserModal.vue'
import UsageAgreementPayroll from '@/widgets/ModalCreateIframe/ui/UsageAgreementPayroll.vue'

import { usePartner } from '@/shared/composables/usePartner'
import { PRODUCT_NAMES } from '@/shared/constants/products'
import { DETAIL_MASS_PAYMENT_GETTERS } from '@/shared/constants/store-constants/detailMassPayment'
import { MASS_PAYMENTS_ROUTES } from '@/shared/constants'
import {
  MASS_PAYMENTS_GETTERS,
  MASS_PAYMENTS_DISPATCHERS,
} from '@/shared/constants/store-constants/massPayments'
import segmentService from '@/shared/services/segment.service'
import { ANALYTICS_EVENT_TYPE } from '@/packages/auth-service/requiredUserAction/shared/utils/analytics'

const router = useRouter()
const store = useStore()

const showCreateMassPayment = ref(false)
const showInviteModal = ref(false)
const showUsageAgreement = ref(false)

const { checkProductAccess } = usePartner()

const massPaymentId = computed(
  () => store.getters[DETAIL_MASS_PAYMENT_GETTERS.id]
)

const termsAccepted = computed(
  () => store.getters[MASS_PAYMENTS_GETTERS.termsAccepted]
)

async function handleMassPaymentStart() {
  const hasAccess = await checkProductAccess(PRODUCT_NAMES.MASS_PAYMENTS)
  if (!hasAccess) {
    return
  }

  segmentService.trackNewEvent(ANALYTICS_EVENT_TYPE.CLICK, {
    event: ANALYTICS_EVENT_TYPE.CLICK,
    page: 'mass_payments',
    screen: 'mass_payments',
    button_name: 'create_payout',
  })

  if (!termsAccepted.value) {
    showUsageAgreement.value = true
    return
  }

  showCreateMassPayment.value = true
}

async function onSignAgreement() {
  await store.dispatch(MASS_PAYMENTS_DISPATCHERS.acceptTerms)
  showUsageAgreement.value = false
  showCreateMassPayment.value = true
}

function onCloseInviteModal() {
  router.push({
    name: MASS_PAYMENTS_ROUTES.DETAIL,
    params: { id: massPaymentId.value },
  })
}

function openInviteModal() {
  showInviteModal.value = true
}
</script>
